/**
 * When a page doesn't require any specific scripts,
 * we at least load the commons one. (Tracking, fonts, etc)
 */
import 'common/common-scripts.js';
